import { render, staticRenderFns } from "./TruncateTooltip.vue?vue&type=template&id=5d7fd604"
import script from "./TruncateTooltip.vue?vue&type=script&lang=js"
export * from "./TruncateTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports